import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink } from "@/types"

export interface IGetTenantSettingsGlobalAssetOverviewDto {
    participation: boolean
    contactInformation?: string | null
    links?: IApiLink[]
}

export interface IUpdateTenantSettingsGlobalAssetOverviewDto {
    participation: boolean
    contactInformation?: string | null
}

export default class TenantSettingsGlobalAssetOverview {
    participation: boolean
    contactInformation?: string
    linkUpdate?: IApiLink

    constructor(dto: IGetTenantSettingsGlobalAssetOverviewDto) {
        this.participation = dto.participation
        this.contactInformation = dto.contactInformation || undefined
        this.linkUpdate = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsGlobalAssetOverview && lnk.rel === ApiLinkRel.update)
    }
}

